import React from 'react';

import {
  Breakpoints,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';

import { StyledTitleContainer } from './styled';
import { useMaintenanceContext } from '../../hooks/use-maintenance-context';

export const MaintenanceTitle = () => {
  const { translationHandler } = useMaintenanceContext();

  return (
    <StyledTitleContainer>
      <TextCustom
        appearance={TextAppearance.headline300}
        tag={TextTag.p}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize20,
            fontWeight: TextWeight.light,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
          [Breakpoints.b1600]: {
            fontSize: TextSize.TextSize32,
            fontWeight: TextWeight.light,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
        }}
      >
        {translationHandler('maintenance.schedule.recommended.label')}
      </TextCustom>
      <TextCustom
        appearance={TextAppearance.headline300}
        tag={TextTag.p}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize24,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight28,
          },
          [Breakpoints.b1600]: {
            fontSize: TextSize.TextSize32,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
        }}
      >
        {translationHandler('maintenance.schedule.maintenance.label')}
      </TextCustom>
    </StyledTitleContainer>
  );
};
